/**
 * Brand storage prefix migration: holecard-ex:* → holdcard-ex:*.
 * Always write the new key; read new first, then legacy fallback.
 */

export const STORAGE_PREFIX = 'holdcard-ex:'
export const STORAGE_PREFIX_LEGACY = 'holecard-ex:'

export function storageKey(suffix: string): string {
  return `${STORAGE_PREFIX}${suffix}`
}

export function storageKeyLegacy(suffix: string): string {
  return `${STORAGE_PREFIX_LEGACY}${suffix}`
}

/** sessionStorage get with legacy fallback; migrates when legacy hit. */
export function sessionGet(suffix: string): string | null {
  const next = storageKey(suffix)
  const legacy = storageKeyLegacy(suffix)
  try {
    const v = sessionStorage.getItem(next)
    if (v != null) return v
    const old = sessionStorage.getItem(legacy)
    if (old != null) {
      try {
        sessionStorage.setItem(next, old)
      } catch {
        // ignore quota
      }
      return old
    }
  } catch {
    // private mode
  }
  return null
}

export function sessionSet(suffix: string, value: string): void {
  try {
    sessionStorage.setItem(storageKey(suffix), value)
  } catch {
    // ignore
  }
}

/** localStorage get with legacy fallback; migrates when legacy hit. */
export function localGet(suffix: string): string | null {
  const next = storageKey(suffix)
  const legacy = storageKeyLegacy(suffix)
  try {
    const v = localStorage.getItem(next)
    if (v != null) return v
    const old = localStorage.getItem(legacy)
    if (old != null) {
      try {
        localStorage.setItem(next, old)
      } catch {
        // ignore
      }
      return old
    }
  } catch {
    // private mode
  }
  return null
}

export function localSet(suffix: string, value: string): void {
  try {
    localStorage.setItem(storageKey(suffix), value)
  } catch {
    // ignore
  }
}
